export default {"src":"/_next/static/media/icon-email.11ed96d8.svg","height":1600,"width":1600};